import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSmell() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      name: isEmpty(state.name),
    };

    setter(errorState);

    if (errorState.name) {
      enqueueSnackbar("لطفا اطلاعات رایحه را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getSmellList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Scents?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const getAllSmellList = (callback) => {
    MyAxios.get(`Admin_Scents?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getSmellByID = (id, callback) => {
    MyAxios.get(`Admin_Scents/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateSmell = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Scents`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("رایحه با موفقیت ادیت شد", {
          variant: "success",
          preventDuplicate: true,
          autoHideDuration: 2000,
        });
        callback();
      }
    });
  };

  const addSmell = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Scents`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("رایحه با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteSmell = (id, callback) => {
    const data = new FormData();
    data.append("ScentID", id);
    MyAxios.delete(`Admin_Scents`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("رایحه با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getAllSmellList,
    getSmellList,
    getSmellByID,
    validate,
    updateSmell,
    addSmell,
    deleteSmell,
  };
}
